import React, {FC} from "react"
import {H6, Label} from "@irati/ui/src/Typography"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import authentication from "@irati/auth"
import {PaymentCurrencyType, WalletEntityType} from "@irati/types"
import {WithDefaultTheme, withTheme} from "styled-components"
import {useBudgetsPermissions} from "@irati/wallet/hooks/budget"

interface Props extends WithDefaultTheme {}

const BudgetAvailableBalance: FC<Props> = ({theme}) => {
  const {canBudget} = useBudgetsPermissions()
  if (canBudget) {
    return null
  }

  return (
    <>
      <H6 paddingLeft={3} paddingTop={4} paddingBottom={4}>
        <FormattedMessage id="wallet.reward.admin.summary.title" />
      </H6>
      <Flex style={{background: theme.colors.utility.highlight}} justifyContent="center" paddingTop={2} paddingBottom={2}>
        <Flex direction="column" alignItems="center">
          <Label small marginBottom={0.5}>
            <FormattedMessage id="wallet.reward.intro.available" />
          </Label>
          <WalletBallance
            variables={{userId: authentication.user().uuid, currency: PaymentCurrencyType.Rp, entityType: WalletEntityType.Reward}}>
            {(apollo) => {
              return <FormattedCurrency value={apollo.data.wallet.amount} currency={PaymentCurrencyType.Rp} />
            }}
          </WalletBallance>
        </Flex>
      </Flex>
    </>
  )
}

export default withTheme(BudgetAvailableBalance)
